import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/defaultV2.min.css';
import { bindSurvey, resetFafBindings } from '../faf/fafHost';
import { fetchFormDefinition, fetchPortalForms } from '../services/workflow';
/**
 * Unauthenticated L1 form for the mobile wrapper. FAF is bound; nothing is submitted.
 */
export function MobileTestPage() {
    const [survey, setSurvey] = useState(null);
    const [error, setError] = useState('');
    useEffect(() => {
        let cancelled = false;
        let boundFormId = null;
        (async () => {
            try {
                const forms = await fetchPortalForms();
                const referral = forms.find((form) => form.kind === 'referral') ?? forms[0];
                if (!referral) {
                    throw new Error('L1 form is not configured');
                }
                const detail = await fetchFormDefinition(referral.formId);
                if (cancelled)
                    return;
                const model = new Model(detail.survey);
                model.showCompleteButton = false;
                model.onCompleting.add((_sender, options) => {
                    options.allowComplete = false;
                });
                const engine = await bindSurvey({
                    formId: referral.formId,
                    bindingKey: referral.formId,
                    survey: model,
                    host: {
                        formId: Number(referral.formId) || referral.formId,
                        incidentId: null,
                        pageUrl: window.location.href,
                    },
                });
                if (!engine) {
                    throw new Error('FAF config did not load for this form');
                }
                if (cancelled) {
                    resetFafBindings(referral.formId);
                    return;
                }
                boundFormId = referral.formId;
                setSurvey(model);
            }
            catch (err) {
                if (!cancelled) {
                    setError(err instanceof Error ? err.message : 'Failed to load the L1 form');
                }
            }
        })();
        return () => {
            cancelled = true;
            if (boundFormId)
                resetFafBindings(boundFormId);
        };
    }, []);
    return (_jsxs("div", { className: "mobile-test-page", children: [!survey && !error && (_jsxs("div", { className: "loading-screen", children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Loading form\u2026" })] })), error && _jsx("p", { className: "form-load-error", children: error }), survey && _jsx(Survey, { model: survey })] }));
}
